"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.studyEditorSchema = exports.STUDY_EDITOR = void 0;
const zod_1 = require("zod");
/**
 * #662 — Which editor an urban study was validated from.
 *
 * A study has two editing interfaces over one record (#634): the **V2**
 * rules-based questionnaire (`/urban-analysis/edit/:id`, the default) and the
 * **V1** legacy panel form (`/urban-analysis/edit/:id/v1`). Each has a report
 * that corresponds to it, and *the interface the architect validated from is
 * what decides which report the study files* — not the study's content, which
 * may hold both kinds or neither.
 *
 * The vocabulary is `V1`/`V2` rather than `LEGACY`/`QUESTIONNAIRE` because the
 * routes, the header's "Version V1" link, the vault note and issue #662 itself
 * already say V1 and V2. A second name for one distinction costs more than it
 * explains.
 *
 * Single source of truth for the two validate actions' input schemas
 * (`urban_analysis_status_action`, `project_form_action`), the two editor pages
 * that declare themselves, and the `report_kind` recorded in `files.metadata`.
 */
exports.STUDY_EDITOR = {
    /** The legacy panel form — fixed fields, filled into a static AcroForm. */
    V1: 'V1',
    /** The rules questionnaire — the default interface, rendered via Typst. */
    V2: 'V2',
};
/**
 * Boundary schema for the `editor` input on both validate actions.
 *
 * **The fallback to `V2` IS requirement FR-007** — "where the originating
 * interface is absent or unrecognised, the system MUST produce the
 * questionnaire report". Expressing it here rather than as a branch further in
 * means nothing downstream has to consider the possibility of an absent editor.
 * Do not remove it to "tighten" the schema: an older browser mid-deploy sends
 * no `editor` at all, and must still be able to validate a study.
 *
 * **`null` counts as absent, not as invalid.** This is `.nullish()` rather than
 * a bare `.default()` because an unset *GraphQL* variable arrives as `null`, not
 * as `undefined` — `project_form_action` is shared by every project form, and
 * only URBAN_ANALYSIS has an editor to name, so the overwhelmingly common call
 * sends an explicit null. Rejecting that 400s every form validation in the app;
 * it did, and the full e2e suite is what caught it.
 *
 * A *wrong* value (e.g. `"V3"`) still throws, so a caller that is confidently
 * incorrect gets a 400 rather than a silent fallback.
 */
exports.studyEditorSchema = zod_1.z
    .enum(Object.values(exports.STUDY_EDITOR))
    .nullish()
    .transform((value) => value ?? exports.STUDY_EDITOR.V2);
//# sourceMappingURL=studyEditor.js.map